// extracted by mini-css-extract-plugin
export default {"provisionBody":"ProvisionCard_provisionBody__l7h0T","tables":"ProvisionCard_tables__Mup5-"};